
import { useLocation } from "react-router-dom";
import { AdministradorNavbar } from "../common/navbar/AdministradorNavbar";
import { EstudianteNavbar } from "../common/navbar/EstudianteNavbar";
import { useSelector } from "react-redux";
import { DocenteNavbar } from "../common/navbar/DocenteNavbar";

export const Navbar = () => {
  const location = useLocation();
  const path = location.pathname;
  const rol = useSelector((store) => store.usuario.rol);

  if (
    (rol === "ADM" || rol === "SADM") &&
    (path.includes("inicio") ||
      path.includes("estudiantes") ||
      path.includes("docentes") ||
      path.includes("programas") ||
      path.includes("idiomas") ||
      path.includes("grupos") ||
      path.includes("turnos") ||
      path.includes("modalidades") ||
      path.includes("horarios") ||
      path.includes("modulos") ||
      path.includes("asignar-modulo") ||
      path.includes("recursos") ||
      path.includes("registro") ||
      path.includes("/pais") ||
      path.includes("/departamento") ||
      path.includes("/provincia") ||
      path.includes("notificaciones") ||
      path.includes("bitacora-asistencias"))
  ) {
    return <AdministradorNavbar />;
  }
  if (
    rol === "EST" &&
    (path.includes("inicio") ||
      path.includes("modulos") ||
      path.includes("historial-notas") ||
      path.includes("calendario-academico") ||
      path.includes("malla-curricular") ||
      path.includes("mis-logros") ||
      path.includes("perfilEstudiante") ||
      path.includes("perfil/editar") ||
      path.includes("control"))
  ) {
    return <EstudianteNavbar />;
  }

  if (
    rol === "DOC" &&
    (path.includes("inicio") ||
      path.includes("idiomas") ||
      path.includes("grupos") ||
      path.includes("asistencia") ||
      path.includes("perfilDocente") ||
      path.includes("calendario-academico") ||
      path.includes("malla-curricular") ||
      path.includes("docentes/plazo-notas") ||
      path.includes("docentes/descargar"))
  ) {
    return <DocenteNavbar />;
  }
  // if (rol === "DOC" && (path.includes("inicio") || path.includes("control"))) {
  //   return <DocenteNavbar />;
  // }
  return <div></div>;
};
